import api from './api';

/**
 * FX Rates Service
 * Handles all FX-related API calls
 */

const fxService = {
  /**
   * Get current/latest FX rates
   */
  getCurrentRates: async () => {
    const response = await api.get('/fx-rates/current');
    return response.data;
  },

  /**
   * Get historical rates for a specific date
   */
  getHistoricalRates: async (date) => {
    const response = await api.get('/fx-rates/historical', { params: { date } });
    return response.data;
  },

  /**
   * Get all rates with pagination
   */
  getRates: async (page = 1, limit = 100) => {
    const response = await api.get('/fx-rates', { params: { page, limit } });
    return response.data;
  },

  /**
   * Lookup rate for a specific currency pair and date
   */
  lookupRate: async (from, to, date) => {
    const response = await api.get('/fx-rates/lookup', { params: { from, to, date } });
    return response.data;
  },

  /**
   * Convert amount from one currency to another
   */
  convertAmount: async (amount, from, to, date) => {
    const response = await api.post('/fx-rates/convert', { amount, from, to, date });
    return response.data;
  },

  /**
   * Manually trigger FX rate fetch from API
   */
  fetchRates: async () => {
    const response = await api.post('/fx-rates/fetch');
    return response.data;
  },

  /**
   * Backfill historical FX rates
   */
  backfillRates: async (startDate = null, endDate = null) => {
    const response = await api.post('/fx-rates/backfill', { startDate, endDate });
    return response.data;
  },

  /**
   * Get backfill status
   */
  getBackfillStatus: async () => {
    const response = await api.get('/fx-rates/backfill-status');
    return response.data;
  },

  /**
   * Add manual rate entry
   */
  addManualRate: async (date, fromCurrency, toCurrency, rate) => {
    const response = await api.post('/fx-rates/manual', {
      date,
      fromCurrency,
      toCurrency,
      rate
    });
    return response.data;
  },

  /**
   * Delete manual rate
   */
  deleteManualRate: async (id) => {
    const response = await api.delete(`/fx-rates/manual/${id}`);
    return response.data;
  },

  /**
   * Get user's reporting currency preference
   */
  getReportingCurrency: async () => {
    const response = await api.get('/fx-rates/reporting-currency');
    return response.data;
  },

  /**
   * Set user's reporting currency preference
   */
  setReportingCurrency: async (currency) => {
    const response = await api.put('/fx-rates/reporting-currency', { currency });
    return response.data;
  },

  /**
   * Get list of supported currencies
   */
  getSupportedCurrencies: async () => {
    const response = await api.get('/fx-rates/currencies');
    return response.data;
  }
};

export default fxService;
